export const getLanguagesList = () => {
    return languagesList.sort((a, b) => a.value.localeCompare(b.value));
};

const languagesList = [
    { value: 'albanian', label: 'Albanian 🇦🇱' },
    { value: 'amharic', label: 'Amharic 🇪🇹' },
    { value: 'arabic', label: 'Arabic 🇸🇦' },
    { value: 'armenian', label: 'Armenian 🇦🇲' },
    { value: 'bengali', label: 'Bengali 🇧🇩' },
    { value: 'bosnian', label: 'Bosnian 🇧🇦' },
    { value: 'bulgarian', label: 'Bulgarian 🇧🇬' },
    { value: 'burmese', label: 'Burmese 🇲🇲' },
    { value: 'catalan', label: 'Catalan 🇪🇸' },
    { value: 'chinese', label: 'Chinese 🇨🇳' },
    { value: 'croatian', label: 'Croatian 🇭🇷' },
    { value: 'czech', label: 'Czech 🇨🇿' },
    { value: 'danish', label: 'Danish 🇩🇰' },
    { value: 'dutch', label: 'Dutch 🇳🇱' },
    { value: 'english', label: 'English 🇬🇧' },
    { value: 'estonian', label: 'Estonian 🇪🇪' },
    { value: 'finnish', label: 'Finnish 🇫🇮' },
    { value: 'french', label: 'French 🇫🇷' },
    { value: 'georgian', label: 'Georgian 🇬🇪' },
    { value: 'german', label: 'German 🇩🇪' },
    { value: 'greek', label: 'Greek 🇬🇷' },
    { value: 'gujarati', label: 'Gujarati 🇮🇳' },
    { value: 'hindi', label: 'Hindi 🇮🇳' },
    { value: 'hungarian', label: 'Hungarian 🇭🇺' },
    { value: 'icelandic', label: 'Icelandic 🇮🇸' },
    { value: 'indonesian', label: 'Indonesian 🇮🇩' },
    { value: 'italian', label: 'Italian 🇮🇹' },
    { value: 'japanese', label: 'Japanese 🇯🇵' },
    { value: 'kannada', label: 'Kannada 🇮🇳' },
    { value: 'kazakh', label: 'Kazakh 🇰🇿' },
    { value: 'korean', label: 'Korean 🇰🇷' },
    { value: 'latvian', label: 'Latvian 🇱🇻' },
    { value: 'lithuanian', label: 'Lithuanian 🇱🇹' },
    { value: 'macedonian', label: 'Macedonian 🇲🇰' },
    { value: 'malay', label: 'Malay 🇲🇾' },
    { value: 'malayalam', label: 'Malayalam 🇮🇳' },
    { value: 'marathi', label: 'Marathi 🇮🇳' },
    { value: 'mongolian', label: 'Mongolian 🇲🇳' },
    { value: 'norwegian', label: 'Norwegian 🇳🇴' },
    { value: 'persian', label: 'Persian 🇮🇷' },
    { value: 'polish', label: 'Polish 🇵🇱' },
    { value: 'portuguese', label: 'Portuguese 🇵🇹' },
    { value: 'punjabi', label: 'Punjabi 🇮🇳' },
    { value: 'romanian', label: 'Romanian 🇷🇴' },
    { value: 'russian', label: 'Russian 🇷🇺' },
    { value: 'serbian', label: 'Serbian 🇷🇸' },
    { value: 'slovak', label: 'Slovak 🇸🇰' },
    { value: 'slovenian', label: 'Slovenian 🇸🇮' },
    { value: 'somali', label: 'Somali 🇸🇴' },
    { value: 'spanish', label: 'Spanish 🇪🇸' },
    { value: 'swahili', label: 'Swahili 🇰🇪' },
    { value: 'swedish', label: 'Swedish 🇸🇪' },
    { value: 'tagalog', label: 'Tagalog 🇵🇭' },
    { value: 'tamil', label: 'Tamil 🇮🇳' },
    { value: 'telugu', label: 'Telugu 🇮🇳' },
    { value: 'thai', label: 'Thai 🇹🇭' },
    { value: 'turkish', label: 'Turkish 🇹🇷' },
    { value: 'ukrainian', label: 'Ukrainian 🇺🇦' },
    { value: 'urdu', label: 'Urdu 🇵🇰' },
    { value: 'vietnamese', label: 'Vietnamese 🇻🇳' },
];
